export const formatDot = (value) => {
  return value && value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const numberWithCommas = (data) => {
  let dataTemp =
    data &&
    data.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  return dataTemp;
};

export const switchDotsAndCommas = (s) => {
  function switcher(match) {
    return match === "," ? "." : ",";
  }
  return s && s.replaceAll(/\.|\,/g, switcher);
};
export const normalizeRoles = (role) =>
  Array.isArray(role) ? role.filter(Boolean) : role ? [role] : [];

export const hasRole = (user, ...allowed) =>
  normalizeRoles(user?.role).some((r) => allowed.includes(r));
